// extracted by mini-css-extract-plugin
module.exports = {"description":"CorruptedFile_description__3UUTO"};